import ControlList from '../../lib/list/ControlList'
import { OrderPaymentData } from './types'

export const controlList = new ControlList<OrderPaymentData>({
    path: '/api/v2/order_payments',
    theads: [
        'Fecha',
        'Usuario',
        'Comprobante',
        'Cliente',
        'Monto',
        'Formas de pago', //'Cond. de pago',
        'Propina',
        'Mozo',
        'Estado',
        'Acciones'
    ]
})
